module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [{
        loading: _vm.list.loading
      },
      'sky-search'
    ]
  }, [_c('div', {
    staticClass: "search-form"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.update($event)
      }
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.parameters.keywords),
      expression: "parameters.keywords",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "Søgetekst ..."
    },
    domProps: {
      "value": (_vm.parameters.keywords)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.parameters.keywords = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), (_vm.messageStatus) ? _c('div', {
    staticClass: "search-message",
    domProps: {
      "innerHTML": _vm._s(_vm.messageStatus)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.list.results.items.length) ? _c('div', {
    staticClass: "search-results"
  }, [_c('ul', _vm._l((_vm.list.results.items), function(item) {
    return _c('li', {
      key: item.id
    }, [_c('h5', [_c('a', {
      attrs: {
        "href": item.url
      },
      domProps: {
        "textContent": _vm._s(item.name)
      }
    })]), _vm._v(" "), _c('small', {
      staticClass: "meta"
    }, [_c('a', {
      staticClass: "url",
      attrs: {
        "href": item.url
      },
      domProps: {
        "textContent": _vm._s(item.url)
      }
    })]), _vm._v(" "), (item.teaser) ? _c('p', {
      staticClass: "teaser",
      domProps: {
        "textContent": _vm._s(item.teaser)
      }
    }) : _vm._e(), _vm._v(" "), _c('ge-link', {
      attrs: {
        "theme": "white",
        "href": item.url
      }
    })], 1)
  }))]) : _vm._e(), _vm._v(" "), (_vm.list.results.pagination.total > _vm.list.results.items.length) ? _c('div', {
    staticClass: "search-more"
  }, [(_vm.list.preferences.pagination && _vm.list.results.pagination.offset != 0) ? _c('button', {
    staticClass: "search-previous ge-link white plain",
    on: {
      "click": _vm.previous
    }
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.messagePrevious)
    }
  }), _vm._v(" "), _c('sky-svg', {
    attrs: {
      "name": "wedge"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.list.results.items.length >= _vm.list.results.pagination.limit) ? _c('button', {
    staticClass: "search-next ge-link white plain",
    on: {
      "click": _vm.next
    }
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.messageNext)
    }
  }), _vm._v(" "), _c('sky-svg', {
    attrs: {
      "name": "wedge"
    }
  })], 1) : _vm._e()]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', [_c('span', [_vm._v("søg")])])
}]}


//////////////////
// WEBPACK FOOTER
// F:/Solutions/6713ge/master/~/vue-loader/lib/template-compiler?{"id":"data-v-f778cc30"}!./scripts/sky-search/sky-search.html
// module id = 364
// module chunks = 1